export const Logo = ({ background = '#2d2eb7' }: { background?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="257.724"
      height="40.003"
      viewBox="0 0 257.724 40.003"
    >
      <g id="Group_3" data-name="Group 3" transform="translate(-178.013 -907.967)">
        <g id="Group_1" data-name="Group 1" transform="translate(178.013 907.967)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M192.95,907.967v3.3H178.013V947.97H206.4v-3.3h14.873V907.967Z"
            transform="translate(-178.013 -907.967)"
            fill={background}
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M209.223,932.473h-6.547l4.63-4.63-2.4-2.4-4.63,4.63v-6.547h-3.4v6.547l-4.63-4.63-2.4,2.4,4.63,4.63h-6.547v3.4h6.547l-4.63,4.63,2.4,2.4,4.63-4.63v6.547h3.4v-6.547l4.63,4.63,2.4-2.4-4.63-4.63h6.547Z"
            transform="translate(-181.966 -914.17)"
            fill="#ff3e00"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M219.546,938.272v6.547h3.4v-6.547l4.63,4.63,2.4-2.4-4.63-4.63h6.547v-3.4h-6.547l4.63-4.63-2.4-2.4-4.63,4.63v-6.547h-3.4v14.748Z"
            transform="translate(-194.574 -914.17)"
            fill="#ff3e00"
          />
        </g>
        <g id="Group_2" data-name="Group 2" transform="translate(234.733 917.686)">
          <path
            id="Path_4"
            data-name="Path 4"
            d="M283.281,944.722l-6.376-9.223v9.223H272.35V924.795h4.555v8.654L283,924.795h5.182L281.46,934.5l7,10.22Z"
            transform="translate(-272.35 -924.396)"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            d="M298.488,934.494a10.363,10.363,0,1,1,10.363,10.363A10.274,10.274,0,0,1,298.488,934.494Zm16.171,0a5.809,5.809,0,1,0-5.808,5.922A5.668,5.668,0,0,0,314.659,934.494Z"
            transform="translate(-282.772 -924.132)"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M353.353,924.795v19.927H348.8v-7.914h-6.263v7.914H337.98V924.795h4.556v7.629H348.8v-7.629Z"
            transform="translate(-298.52 -924.396)"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M382.428,929.179H377.3v15.543h-4.556V929.179h-5.123v-4.384h14.8Z"
            transform="translate(-310.341 -924.396)"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M410.838,931.627a6.848,6.848,0,0,1-6.975,6.832h-2.989v6.263H396.32V924.795h7.544A6.848,6.848,0,0,1,410.838,931.627Zm-4.555,0a2.435,2.435,0,0,0-2.42-2.562h-2.989v5.124h2.989A2.435,2.435,0,0,0,406.284,931.627Z"
            transform="translate(-321.783 -924.396)"
          />
          <path
            id="Path_9"
            data-name="Path 9"
            d="M432.241,941.591h-7.4l-1,3.131h-4.981l6.776-19.927h5.807l6.776,19.927h-4.983Zm-1.366-4.27L428.54,930l-2.335,7.316Z"
            transform="translate(-330.771 -924.396)"
          />
          <path
            id="Path_10"
            data-name="Path 10"
            d="M465.592,944.722l-6.377-9.223v9.223H454.66V924.795h4.554v8.654l6.092-8.654h5.182L463.77,934.5l7,10.22Z"
            transform="translate(-345.046 -924.396)"
          />
          <path
            id="Path_11"
            data-name="Path 11"
            d="M497.5,929.179h-5.124v15.543h-4.555V929.179h-5.124v-4.384h14.8Z"
            transform="translate(-356.224 -924.396)"
          />
          <path
            id="Path_12"
            data-name="Path 12"
            d="M522.491,933.9,514.8,944.722h-3.416V924.795h4.555v10.818l7.686-10.818h3.416v19.927h-4.555Z"
            transform="translate(-367.666 -924.396)"
          />
          <path
            id="Path_13"
            data-name="Path 13"
            d="M558.49,924.795l-5.75,14.063c-1.766,4.3-4.641,6.064-8.37,5.864v-4.27a3.634,3.634,0,0,0,3.985-1.964l-6.376-13.693h4.555l3.9,8.711,3.5-8.711Z"
            transform="translate(-379.864 -924.396)"
          />
          <path
            id="Path_14"
            data-name="Path 14"
            d="M593.443,944.722h-4.554V933.136l-5.152,8.455h-.513l-5.152-8.455v11.586h-4.555V924.795h4.555l5.409,8.854,5.409-8.854h4.554Z"
            transform="translate(-392.439 -924.396)"
          />
        </g>
      </g>
    </svg>
  );
};
